module.exports = __webpack_public_path__ + "img/117.ce4c5727.png";